export default __webpack_public_path__ + "static/18-0fa872614b06c00b2a332a6545b13fed.jpg";